export enum ROLES {
    ADMIN = 'ADMIN',
    USER = 'USER',
    CUSTOM_HOUSING_AGENT = 'CUSTOM_HOUSING_AGENT',
    REGISTRATION = 'REGISTRATION',
    COMPANY = 'COMPANY',
    AFFILIATE = 'AFFILIATE',

    // Internal LumberLinq / Rikexim staff roles (created via the admin Employee-onboarding flow).
    // Bare names as stored in the `role` table and returned by /progress — no ROLE_ prefix.
    SUPPORT = 'SUPPORT',
    SALES = 'SALES',
    SALES_MANAGER = 'SALES_MANAGER',

    ROLE_ADMIN = 'ROLE_ADMIN',
    ROLE_USER = 'ROLE_USER',
    ROLE_SUPER_ADMIN = 'ROLE_SUPER_ADMIN',
    ROLE_ROOT = 'ROLE_ROOT'
}
